import React, { useEffect, useState } from 'react';
import { Form, Row, Col, FloatingLabel } from 'react-bootstrap/esm';
import { ref, child, get } from 'firebase/database';
import { db } from '../../../../FirebaseConfig';
import styles from './QueueList.module.scss';
import Ribbon from '../../../common/Toast';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { getUsersOrganizations } from '../../../../api/organization';
import { getUsersQueues } from '../../../../api/queue';
import { Spinner } from 'react-bootstrap';

function QueueList() {
  const { ...params } = useParams();
  const navigate = useNavigate();
  const hostId = JSON.parse(localStorage.getItem('user'));

  const [queues, setQueues] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [selectedQueue, setSelectedQueue] = useState(params.queueId || '');
  const [userId, setUserId] = useState(hostId.uid || null);
  const [selectedOrg, setSelectedOrg] = useState('all');
  const [filteredQueues, setFilteredQueues] = useState([]);
  const [loading, setLoading] = useState(true);  // Loading state to track the fetching

  useEffect(() => {
    if (filteredQueues.find((q) => q.id === params.queueId)) {
      setSelectedQueue(params.queueId);
    } else {
      setSelectedQueue('');
    }
  }, [params, queues]);

  useEffect(() => {
    if (userId) {
      setLoading(true);
      async function getData() {
        try {
          const ques = await getUsersQueues(userId);
          const queuesArray = [];
          for (let q in ques) {
            queuesArray.push(ques[q]);
          }
          setQueues(queuesArray);
          setFilteredQueues(queuesArray);
        } catch (e) {
          console.error(e);
        }finally {
          setLoading(false);
        }

        try {
          const orgs = await getUsersOrganizations(userId);
          setOrganizations(orgs);
        } catch (e) {
          console.error(e);
        }
      }
      getData();
    }
  }, [userId]);
  const handleChange = (e) => {
    navigate(`/dashboard/queue/monitor/${e.target.value}`);
  };

const onOrgFilter = (e) => {
  setSelectedOrg(e.target.value);
  setSelectedQueue('');
};

  useEffect(() => {
    switch (selectedOrg) {
      case 'all':
        setFilteredQueues(queues);
        break;
      case 'none':
        setFilteredQueues(queues.filter((q) => !q.organizationId));
        break;
      default:
        setFilteredQueues(
          queues.filter((q) => q.organizationId === selectedOrg)
        );
    }
  }, [selectedOrg]);

  if (loading) {
    return (
      <div className="spinnerWrapper">
        <Spinner animation="border" className="customSpinner" />
          <span>Loading...</span>
      </div>
    );
  }
  if (hostId === null)
    return (
      <Ribbon
        title="Temporary warning!"
        subTitle="Please sign up to work on this page."
      />
    );
  else if (queues.length === 0)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '70vh',
        }}
      >
        <div className={''}>
          <h4 className={'pb-3'}>
            {' '}
            Hi, looks like you don't have any active queues.
          </h4>
          <p>Following these step below to make your work run smoothly : </p>
          <p> ✏️ Create some actives queues for your events</p>
          <p>
            {' '}
            ✏️ Access the queue codes of your events or save the QR codes by
            open the Queue Information in the Queue Management section{' '}
          </p>
          <p> ✏️ Share your queue codes or QR code images to your customers </p>
          <p> ....Then wait for serving</p>

          <p> 💹 Happy business!!!</p>
        </div>
      </div>
    );

  return (
    <>
      <div className={styles['filters-wrap']}>
        <FloatingLabel
          xs={5}
          controlId="floatingInputGrid"
          label="Choose Organization"
        >
          {organizations && (
            <Form.Select
              id="orgName"
              onChange={onOrgFilter}
              value={selectedOrg}
              data-cypress-name = 'filter-org'
            >
              <option value={'all'}>All</option>
              <option value={'none'}>No organization</option>
              {organizations.map((org) => (
                <option
                  key={org.id}
                  value={org.id}
                  tabIndex="0"
                  className={styles['my-queue-item']}
                >
                  {org.orgName}
                </option>
              ))}
            </Form.Select>
          )}
        </FloatingLabel>
        <FloatingLabel
          xs={5}
          controlId="floatingInputGrid"
          label="Choose Event"
        >
          {queues && (
            <Form.Select
              id="queueName"
              onChange={handleChange}
              value={selectedQueue}
              data-cypress-name = 'filter-queue'
            >
              <option disabled={true} value="">
                Select queue name
              </option>
              {filteredQueues.map((queue) => {
                return (
                  <option
                    key={queue.id}
                    value={queue.id}
                    tabIndex="0"
                    className={styles['my-queue-item']}
                  >
                    {queue.name}
                  </option>
                );
              })}
            </Form.Select>
          )}
        </FloatingLabel>
      </div>
    </>
  );
}
export default QueueList;
